module.exports = __webpack_public_path__ + "img/shareholders_rights1.eb1485c4.jpg";